var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secure-payment"},[(_vm.AcsUrl)?_c('form',{ref:"threeDomainSecure",attrs:{"method":"post","action":_vm.AcsUrl}},[_c('input',{attrs:{"type":"hidden","name":"creq"},domProps:{"value":_vm.creq}}),_c('input',{attrs:{"type":"hidden","name":"threeDSSessionData"},domProps:{"value":_vm.threeDSSessionData}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }